import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateMissionBillings } from '@store/slice/missionBillingSlice'
import { updateNotification } from '@store/slice/mainSlice'
import { missionBillingFormObject } from '@form/missionBillingFormFields'
import { get } from '@util/xhrAPI'
import { useTranslation } from 'react-i18next'
import useDynamicForm from '@hook/useDynamicForm'
import useDeleteButton from '@hook/useDeleteButton'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table"
import Alert from '@ui/elements/Alert'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'

const ListMissionBillings = () => {
  const { missionBillings } = useSelector(state => state.missionBillings)
  const { mission } = useSelector(state => state.main)
  const theme = useTheme(getTheme())
  const dispatch = useDispatch()
  const toggleDynamicForm = useDynamicForm()
  const deleteButton = useDeleteButton()
  const [t] = useTranslation('common')

  const dataDistricts = { nodes: [] }
  if (missionBillings) {
    dataDistricts.nodes = Object.values(missionBillings)
  }

  const removeMissionBilling = missionBilling => {
    const { id, links } = missionBilling
    get(`${import.meta.env.VITE_API_URL}${links.remove}`, response => {
      const { code } = response
      if (code === 200) {
        const district = missionBillings[id]
        const missionBillingsList = { ...missionBillings }
        delete missionBillingsList[id]
        dispatch(updateMissionBillings({ ...missionBillingsList }))
        dispatch(updateNotification({ type: 'is-success', message: t('messages.removed_successfuly', { title: district.name }) }))
      } else {
        dispatch(updateNotification({ type: 'is-danger', message: t('messages.error_occured') }))
      }
    })
  }

  useEffect(() => {
    get(`${import.meta.env.VITE_API_URL}/api/missions/${mission.id}/mission-billings`, response => {
      const { code, missionBillings } = response
      if (code === 200) {
        dispatch(updateMissionBillings(missionBillings))
      }
    })
  }, [])

  return (
    <Div cssClass='users-list'>
      <Div cssClass='actions-zone'>
        <Buttons buttons={{
          icon: 'icon-add',
          cssClass: 'is-info is-small',
          callback: () => toggleDynamicForm('missionBilling', null, { ...missionBillingFormObject, billingType: mission.billingType?.id }),
          text: t('actions.add')
        }}
        />
      </Div>
      <h2 className='zone-title'>{t('titles.mission_billings_list')}</h2>
      {null !== missionBillings && dataDistricts.nodes.length
        ? <>
          <Table data={dataDistricts} theme={theme}>
            {(tableList) => (
              <>
                <Header>
                  <HeaderRow>
                    <HeaderCell>{t('table.BillingModel')}</HeaderCell>
                    <HeaderCell>{t('table.Min')}</HeaderCell>
                    <HeaderCell>{t('table.Max')}</HeaderCell>
                    <HeaderCell>{t('table.Cost')}</HeaderCell>
                    {mission.isCompany && <HeaderCell>{t('table.CompanyCost')}</HeaderCell>}
                    {mission.isCoOwnership && <HeaderCell>{t('table.CoOwnershipCost')}</HeaderCell>}
                    <HeaderCell>Actions</HeaderCell>
                  </HeaderRow>
                </Header>
                <Body>
                  {tableList.map(item =>
                    <Row key={item.id} item={item}>
                      <Cell>{item.billingType?.name}</Cell>
                      <Cell>{item.min}</Cell>
                      <Cell>{item.max}</Cell>
                      <Cell>{item.cost} €</Cell>
                      {mission.isCompany && <Cell>{item.companyCost} €</Cell>}
                      {mission.isCoOwnership && <Cell>{item.coOwnershipCost} €</Cell>}
                      <Cell className='table-actions'>
                        <Buttons buttons={[
                          {
                            icon: 'icon-create',
                            cssClass: 'is-info is-small',
                            callback: () => toggleDynamicForm('missionBilling', null, { ...item, billingType: mission.billingType?.id })
                          }
                        ]} />
                        {deleteButton(item, item.name, removeMissionBilling)}
                      </Cell>
                    </Row>
                  )}
                </Body>
              </>
            )}
          </Table>
        </>
        : <Alert type='is-info' message={t('messages.empty_list')} />
      }
    </Div>
  )
}

export default ListMissionBillings